// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:8f9e378a-b9cc-4195-860c-a6ab1f7aee20",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_uUg0sPYuX",
    "aws_user_pools_web_client_id": "1kdart415vmu670qfke2r81n8o",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://pmpekbnybfdjvccxayqusttcia.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
